<template>
  <div class="nebTree"
    :style="{
      maxHeight,
      minHeight: '40px'
    }"
    :class="{
      'hasMaxHeight':  maxHeight !== 'unset'
    }"
    v-loading="loading"
  >
    <tree-node v-for="node in nodes"
      :key="node.value"
      :node="node"
      :selected="selected"
      :selectable="selectable"
      :singleSelect="singleSelect"
      @nodeClick="onNodeClick"
    ></tree-node>
  </div>
</template>

<script>
import { includes } from 'lodash'
import TreeNode from './TreeNode'

export default {
  name: 'Tree',

  components: {
    TreeNode
  },

  props: {
    /**
     * All node values within the treet MUST have unique values in order for
     * selectable to work.
     */
    selectable: {
      type: Boolean,
      default: false
    },
    singleSelect: {
      type: Boolean,
      default: false
    },
    selected: {
      type: [Array, String],
      default: () => []
    },
    nodes: {
      type: Array,
      default: () => []
    },
    maxHeight: {
      type: String,
      default: 'unset'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onNodeClick (node) {
      if (!this.selectable) {
        this.$emit('nodeClick', node)
        return
      }

      if (this.singleSelect) {
        return this.selected === node.value
          ? this.$emit('select', '')
          : this.$emit('select', node.value)
      }

      let newSelected = []

      if (includes(this.selected, node.value)) {
        newSelected = this.selected
          .filter(item => item !== node.value)
      } else {
        newSelected = this.selected.concat([node.value])
      }

      this.$emit('select', newSelected)
    }
  }
}
</script>

<style lang="scss">
.nebTree {
  overflow-x: hidden;
  overflow-y: scroll;

  &.hasMaxHeight {
    padding-right: 15px;
  }
}
</style>
